import { inject } from '@angular/core'
import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http'
import { Router } from '@angular/router'
import { catchError, throwError } from 'rxjs'
import { AuthenticationService } from '@app/auth-management/authentication.service'

// 401 means the session itself is invalid/expired (no refresh-token strategy yet),
// so drop the stale session and send the user to log back in rather than letting
// them land on a dead page. 403 means the session is valid but lacks permission,
// which stays a distinct "forbidden" page.
export const authorizationErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router)
  const authentication = inject(AuthenticationService)

  return next(req).pipe(
    catchError((error: unknown) => {
      if (error instanceof HttpErrorResponse && error.status === 401) {
        // Always drop the stale session, even if the 401'd request was fired from
        // /login itself (e.g. fetching the active user right after a stale token) —
        // otherwise the stored token lingers, LoginPageComponent keeps thinking the
        // user is authenticated, and it keeps retrying the same failing request.
        // Only the *navigation* needs the loop guard.
        authentication.clearAuthentication()
        if (!router.url.startsWith('/login')) {
          router.navigate(['/login'])
        }
      } else if (error instanceof HttpErrorResponse && error.status === 403) {
        router.navigate(['/403'])
      }
      return throwError(() => error)
    })
  )
}
